import { render, staticRenderFns } from "./trainingRecordView.vue?vue&type=template&id=08919b34&scoped=true"
import script from "./trainingRecordView.vue?vue&type=script&lang=js"
export * from "./trainingRecordView.vue?vue&type=script&lang=js"
import style0 from "./trainingRecordView.vue?vue&type=style&index=0&id=08919b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08919b34",
  null
  
)

export default component.exports